module.exports = __webpack_public_path__ + "img/product_25.25b771b.webp";